import script from "./TableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableRow.vue?vue&type=script&setup=true&lang=ts"

import "./TableRow.vue?vue&type=style&index=0&id=d7b283d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7b283d4"]])

export default __exports__